export enum Portals { ADMIN = 'admin', MANAGE = 'manage', TRACK = 'track' }
export type Portal = `${Portals}`;

export const PortalTypes = {
  THING_TYPE: 'thing-type',
  PERSON_TYPE: 'person-type',
  THING_PERSON_TYPE: 'thing-person-type',
} as const;
